Vendd.Scripts.load(function () {
    var $wrapper = $('.x-control.x-page-mode');

    if ($wrapper.length < 1) return;

    var wrapper = $wrapper.get(0),
        model = null;

    wrapper.bind = function () {
        var plMode = Cookies.get('plMode');

        if (plMode == "grid") {
            $('.page-mode-btn', $wrapper).removeClass('selected');
            $('.page-mode-btn.grid', $wrapper).addClass('selected');
            $('.x-main-product-list .x-product-list').removeClass('horizontal-products').addClass('vertical-products');
        } else if (plMode == "list") {
            $('.page-mode-btn', $wrapper).removeClass('selected');
            $('.page-mode-btn.list', $wrapper).addClass('selected');
            $('.x-main-product-list .x-product-list').removeClass('vertical-products').addClass('horizontal-products');
        }

        $('.x-control.x-page-mode').each(function (i, wrapper) {
            var $wrapper = $(wrapper);
            var $pageModeBtn = $('.page-mode-btn', $wrapper);

            $wrapper.on('click', '.page-mode-btn', function (e) {
                $pageModeBtn.removeClass('selected');
                $(this).addClass('selected');
                if ($(this).hasClass('grid')) {
                    $('.x-main-product-list .x-product-list').removeClass('horizontal-products').addClass('vertical-products');
                    Cookies.set("plMode", "grid", { expires: 10, samesite: 'Lax' });
                } else if ($(this).hasClass('list')) {
                    $('.x-main-product-list .x-product-list').removeClass('vertical-products').addClass('horizontal-products');
                    Cookies.set("plMode", "list", { expires: 10, samesite: 'Lax' });
                }
            });

        });
    };

    wrapper.update = function () {
        var html = Vendd.Handlebars.parse("plPageMode_A", model);
        $wrapper.html(html);
        wrapper.bind();
    };

    wrapper.bind();
    
    Vendd.MessageBus.subscribe(Vendd.ProductList.Messages.GetModelSuccess, $wrapper, function (envelope) {
        if (envelope.message.data.data.Products.Items.length < 1)
            return;

        model = envelope.message.data.data.PageMode;
        wrapper.update();
    });

});
